// @file Network requests related to Whiteboard Script from sandbox

import { asciiSafeStringify } from '@@/bits/json_stringify'
import type { VersionedFetchOptions } from '@@/surface/api/fetchable_object'
import FetchableObject from '@@/surface/api/fetchable_object'
import { fetchJson } from '@@/surface/api_fetch'
import type { WallId } from '@@/types'
import type { BlocklyScriptBlocks, WhiteboardScript as WhiteboardScriptType } from '@@/types/whiteboard'
import { HTTPMethod } from '@padlet/fetch'

class WhiteboardScriptApi extends FetchableObject {
  public static get whiteboardScriptUrl(): string {
    return `/api/\${ apiVersion }/walls/\${ wallId }/whiteboard-script`
  }

  public static async fetch(
    wallId: WallId,
    fetchOptions: VersionedFetchOptions = { apiVersion: 1 },
  ): Promise<WhiteboardScriptType[]> {
    const { apiVersion, ...restFetchOptions } = fetchOptions

    const response = await fetchJson(this.buildUrl(this.whiteboardScriptUrl, { wallId, apiVersion }), {
      method: HTTPMethod.get,
      ...restFetchOptions,
    })

    return response?.data?.attributes
  }

  public static async upsert(
    wallId: WallId,
    shapeId: string,
    script: BlocklyScriptBlocks,
    fetchOptions: VersionedFetchOptions = { apiVersion: 1 },
  ): Promise<void> {
    const { apiVersion, ...restFetchOptions } = fetchOptions

    await fetchJson(this.buildUrl(this.whiteboardScriptUrl, { wallId, shapeId, apiVersion }), {
      method: HTTPMethod.put,
      body: asciiSafeStringify({
        data: {
          type: 'wall_whiteboard_script',
          attributes: {
            script,
            shapeId,
          },
        },
      }),
      ...restFetchOptions,
    })
  }
}

export { WhiteboardScriptApi }
